import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/tracing";

const configSentry = () => {
    let UNIQUE_CLIENT_ID, REQUEST_ID, USER_IP
    let arrayb = document?.cookie?.split(";");
    // console.log("---  Cookies  ---");
    for (let item of arrayb) {
        const [keyCookie, value] = item.trim().split("=")
        // console.log({keyCookie, value});
        if (keyCookie.trim().startsWith("unique_client_id")) UNIQUE_CLIENT_ID = value
        if (keyCookie.trim().startsWith("request-id")) REQUEST_ID = value
        if (keyCookie.trim().startsWith("user-ip")) USER_IP = value
    }
    
    // console.log("process.env.SENTRY_DNS_FRONTEND = '" + process.env.SENTRY_DNS_FRONTEND + "'");
    Sentry.init({
        dsn: process.env.SENTRY_DNS_FRONTEND,
        debug: false,
        environment: (process.env.NODE_ENV === 'production' && process.env.DEV_ENV === 'PRO') ? "production" : "development",
        allowUrls: [process.env.HOST_ADOPTA, process.env.CDN_URL],
        ip: true,
        integrations: [
            new BrowserTracing(),
            new Sentry.Replay({
                // Additional SDK configuration goes in here, for example:
                maskAllText: false, //default: true
                blockAllMedia: false, //default: true
                maskAllInputs: false, //default: true
            })],
        // replaysSessionSampleRate: 0.1,
        replaysSessionSampleRate: (process.env.NODE_ENV === 'production' && process.env.DEV_ENV === 'PRO') ? 0.1 : 1.0,
        
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
        
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: (process.env.NODE_ENV === 'production' && process.env.DEV_ENV === 'PRO') ? 0.3 : 1.0,
        
        // initialScope: {
        // tags: {
        //     unique_client_id : UNIQUE_CLIENT_ID
        // },
        // user: {ip: USER_IP, email: "john.doe1@example.com", unique_client_id: UNIQUE_CLIENT_ID},
        // },

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", process.env.HOST_ADOPTA],
        ignoreErrors: [
            'themoneytizer',
            'ads.themoneytizer.com',
            'script.4dex.io',
            // Random plugins/extensions
            'top.GLOBALS',
            // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
            'originalCreateNotification',
            'canvas.contentDocument',
            'MyApp_RemoveAllHighlights',
            'http://tt.epicplay.com',
            "Can't find variable: ZiteReader",
            'jigsaw is not defined',
            'ComboSearch is not defined',
            'http://loading.retry.widdit.com/',
            'atomicFindClose',
            // Facebook borked
            'fb_xd_fragment',
            // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
            // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
            'bmi_SafeAddOnload',
            'EBCallBackMessageReceived',
            // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
            'conduitPage',
            // Generic error code from errors outside the security sandbox
            // You can delete this if using raven.js > 1.0, which ignores these automatically.
            'Script error.',
            // Avast extension error
            '_avast_submit',
        ],
        denyUrls: [
            /themoneytizer/i,
            /ads\.themoneytizer\.com/i,
            /cdns\.helion\.exchange/i,
            /script\.4dex\.io/i,
            /js\/lib\.js/i,
            /cdns\.helion\.exchange\/media\/native\/300x250\/js\/lib\.js/i,
            /cdns\.helion\.exchange\/media\/native\/320x100\/js\/lib\.js/i,
            // Google Adsense
            /pagead\/js/i,
            // Facebook flakiness
            /graph\.facebook\.com/i,
            // Facebook blocked
            /connect\.facebook\.net\/en_US\/all\.js/i,
            // Woopra flakiness
            /eatdifferent\.com\.woopra-ns\.com/i,
            /static\.woopra\.com\/js\/woopra\.js/i,
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            // Other plugins
            /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        ],
    });
    Sentry.setUser({ip: USER_IP, /*email: "john.doe2@example.com",*/ unique_client_id: UNIQUE_CLIENT_ID});
    
    Sentry.configureScope(scope => {
        scope.setContext("Request", {
            unique_client_id: UNIQUE_CLIENT_ID,
            request_id: REQUEST_ID,
            user_ip: USER_IP,
        });
    });
    
};


export default configSentry;